import {Injectable} from '@angular/core';
import {
  HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,
  HttpResponse
} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';

import {UserService} from '../user/user.service';
import {SnackMessageService} from '../snack-messages/snack-message.service';
import {SnackMessage} from '../snack-messages/snack-message.model';
import {DialogMessageService} from '../dialog-messages/dialog-message.service';
import {DialogMessage} from '../dialog-messages/dialog-message.model';
import {GlobalVariable} from '../../global';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {

  constructor(private userService: UserService,
              private snackMessageService: SnackMessageService,
              private dialogMessageService: DialogMessageService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (this.userService.userExists() &&
    ( req.url.includes(GlobalVariable.BASE_API_URL) 
    || req.url.includes(GlobalVariable.BASE_COLLECT_API_URL))
      && !req.url.includes(GlobalVariable.BASE_API_URL + '/public') ) {

      const token: string = this.userService.getToken();
      const authReq = req.clone({headers: req.headers.set('X-Auth-Token', token)});

      return next.handle(authReq).catch(
        (err: any, caught: Observable<any>) => {
          if (err.status === 0) {
            const message = 'ERROR CONNEXION TO SERVER';
            this.snackMessageService.newMessage.next(new SnackMessage('danger', message));
            err.error.message = message;
            err.error = JSON.stringify(err.error);
          }
          return Observable.throw(err);
        }
      ).do((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // disable snackmessage for operations (deposit-account-operation and operation) but not for operation-cost
          if (!req.url.includes('operation') || req.url.includes('operation-cost')) {
            if (event.status > 200 || req.method === 'PUT') {
              const snackMessage = new SnackMessage('success', 'SUCCESS');
              switch (event.status) {
                case 200 :
                  snackMessage.message = 'RESOURCE UPDATED';
                  break;
                case 201 :
                  snackMessage.message = 'RESOURCE CREATED';
                  break;
                case 204 :
                  if (req.url.includes('auth-token')) {
                    snackMessage.message = 'LOGOUT';
                    snackMessage.type = 'danger';
                  } else {
                    snackMessage.message = 'RESOURCE DELETED';
                    snackMessage.type = 'danger';
                  }
                  break;
              }
              this.snackMessageService.newMessage.next(snackMessage);
            }
          }
        }
      }, (err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401) {
            this.userService.currentUser.next(null);
            this.snackMessageService.newMessage.next(new SnackMessage('danger', 'INVALID AUTHENTIFICATION'));
          } else {
            if (!req.url.includes('operation')) {
              const snackMessage = new SnackMessage('danger', 'ERROR');
              switch (err.status) {
                case 400 :
                  snackMessage.message = 'FORM ERROR';
                  break;
                case 404 :
                  snackMessage.message = 'RESSOURCE NOT FOUND';
                  break;
                case 500 :
                  snackMessage.message = 'INTERNAL SERVER ERROR';
                  break;
              }
              this.snackMessageService.newMessage.next(snackMessage);
              if (err.status !== 404) {
                this.dialogMessageService.newMessage.next(new DialogMessage('danger', err));
              }
            }else{
               this.dialogMessageService.newMessage.next(new DialogMessage('danger', err));
            }
          }

        }
      });
    }else {
      return next.handle(req).catch(
        (err: any, caught: Observable<any>) => {
          if (err.status === 0) {
            const message = 'ERROR CONNEXION TO SERVER';
            this.snackMessageService.newMessage.next(new SnackMessage('danger', message));
            err.error.message = message;
            err.error = JSON.stringify(err.error);
          }
          return Observable.throw(err);
        }
      );
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/auth/auth-interceptor.service.ts